module.exports = __webpack_public_path__ + "static/media/img_logo_aircash.57feb9cd.png";